import React from "react";

const BenefitsCard = ({ data }) => {
  return (
    <div className="benefits-card">
      <img src={data.img} alt={data.title} />
      <div className="benefits-content">
        <p className="benefits-content-title">{data.title}</p>
        <p className="benefits-content-desc">{data.desc}</p>
      </div>
    </div>
  );
};

export default BenefitsCard;
